jQuery(document).ready(function(){
  jQuery('.filter__list li a').click(function(e){
        e.preventDefault();
        jQuery('.filter__list li a').removeClass('active');
        jQuery(this).addClass('active');
        var filter = jQuery(this).text();
        jQuery('.logo-list .logo-list__item').hide();
        jQuery('.logo-list .logo-list__item').each(function(index, value) {
          if(jQuery(this).data('category').includes(filter)){
              jQuery(this).show();
          }
        });
        if(filter == 'All'){
          jQuery('.logo-list .logo-list__item').show();
        }
  });
});